import Myapplications from "../../../jsx/components/Dashboard/MyApplications/myapplications";

const MyApplicationWrapper = () => {
  return <Myapplications />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(MyApplicationWrapper);
